import dayjs from 'dayjs';

function formatSingleDateKey(dateKey: string, localeCode: string): string {
    const date = dayjs(dateKey);
    if (localeCode === 'fr' || localeCode === 'es') {
        return date.format('DD/MM/YYYY');
    }
    return date.format('YYYY/MM/DD');
}

function formatDateRangeKeys(startKey: string, endKey: string, localeCode: string): string {
    if (startKey === endKey) {
        return formatSingleDateKey(startKey, localeCode);
    }

    const start = dayjs(startKey);
    const end = dayjs(endKey);
    const useEuropean = localeCode === 'fr' || localeCode === 'es';

    if (useEuropean) {
        if (start.year() === end.year() && start.month() === end.month()) {
            return `${start.format('DD')}–${end.format('DD/MM/YYYY')}`;
        }
        if (start.year() === end.year()) {
            return `${start.format('DD/MM')}–${end.format('DD/MM/YYYY')}`;
        }
        return `${start.format('DD/MM/YYYY')} – ${end.format('DD/MM/YYYY')}`;
    }

    if (start.year() === end.year() && start.month() === end.month()) {
        return `${start.format('YYYY/MM/')}${start.format('DD')}–${end.format('DD')}`;
    }
    return `${start.format('YYYY/MM/DD')} – ${end.format('YYYY/MM/DD')}`;
}

/**
 * Collapse sorted calendar-day keys (YYYY-MM-DD) into locale-aware range labels.
 * e.g. ["2026-06-22","2026-06-23","2026-06-24","2026-06-25"] → "22–25/06/2026" (es/fr)
 */
export function formatSelectedDatesAsRanges(dateKeys: string[], localeCode: string): string {
    if (dateKeys.length === 0) {
        return '';
    }

    const sorted = [...dateKeys].sort();
    const ranges: Array<{ start: string; end: string }> = [];
    let rangeStart = sorted[0];
    let rangeEnd = sorted[0];

    for (let index = 1; index < sorted.length; index += 1) {
        const previous = dayjs(rangeEnd);
        const current = dayjs(sorted[index]);
        if (current.diff(previous, 'day') === 1) {
            rangeEnd = sorted[index];
        } else {
            ranges.push({ start: rangeStart, end: rangeEnd });
            rangeStart = sorted[index];
            rangeEnd = sorted[index];
        }
    }
    ranges.push({ start: rangeStart, end: rangeEnd });

    return ranges
        .map(({ start, end }) => formatDateRangeKeys(start, end, localeCode))
        .join(', ');
}
